export interface ArchiveTab {
  resource: string;
  labelKey: string;
  archivePath: string;
  entityPath: string;
  url?: string;
  identifierLabelKey?: string;
  hasParent?: boolean;
}

export const archiveTabRoutePath = (tab: ArchiveTab) =>
  (tab.url ?? `${tab.resource}s`).toLowerCase();

export const archiveTabs: ArchiveTab[] = [
  {
    resource: 'articleTemplate',
    labelKey: 'configuration.navigation.articleTemplates',
    archivePath: 'articletemplates',
    entityPath: 'articletemplates',
  },
  {
    resource: 'article',
    labelKey: 'general.articles',
    archivePath: 'articles',
    entityPath: 'articles',
    identifierLabelKey: 'general.itemCode',
    hasParent: true,
  },
  {
    resource: 'concept',
    labelKey: 'general.concepts',
    archivePath: 'concepts',
    entityPath: 'concepts',
    hasParent: true,
  },
  {
    resource: 'country',
    labelKey: 'configuration.navigation.countries',
    archivePath: 'metadata/countries',
    entityPath: 'metadata/countries',
    url: 'countries',
    identifierLabelKey: 'general.code',
    hasParent: true,
  },
  {
    resource: 'currency',
    labelKey: 'configuration.navigation.currencies',
    archivePath: 'currencies',
    entityPath: 'currencies',
    url: 'currencies',
    identifierLabelKey: 'general.code',
    hasParent: true,
  },
  {
    resource: 'customer',
    labelKey: 'general.customers',
    archivePath: 'customers',
    entityPath: 'customers',
  },
  {
    resource: 'deliveryMethod',
    labelKey: 'configuration.navigation.deliveryMethod',
    archivePath: 'deliverymethods',
    entityPath: 'deliverymethods',
    identifierLabelKey: 'configuration.identifier',
    hasParent: true,
  },
  {
    resource: 'deliveryTerm',
    labelKey: 'configuration.navigation.deliveryTerms',
    archivePath: 'deliveryterms',
    entityPath: 'deliveryterms',
    identifierLabelKey: 'configuration.identifier',
    hasParent: true,
  },
  {
    resource: 'file',
    labelKey: 'fileBrowser.files',
    archivePath: 'files',
    entityPath: 'files',
    hasParent: true,
  },
  {
    resource: 'folder',
    labelKey: 'fileBrowser.folders',
    archivePath: 'folders',
    entityPath: 'folders',
    hasParent: true,
  },
  {
    resource: 'freightCost',
    labelKey: 'configuration.navigation.freightCosts',
    archivePath: 'freightcosts',
    entityPath: 'freightcosts',
  },
  {
    resource: 'handlingFee',
    labelKey: 'configuration.navigation.handlingFees',
    archivePath: 'handlingfees',
    entityPath: 'handlingfees',
  },
  {
    resource: 'matrixNode',
    labelKey: 'configuration.navigation.matrixNodes',
    archivePath: 'matrixnodes',
    entityPath: 'matrixnodes',
  },
  {
    resource: 'matrixNodeValue',
    labelKey: 'archivePage.matrixNodeValues',
    archivePath: 'matrixnodevalues',
    entityPath: 'matrixnodevalues',
    identifierLabelKey: 'configuration.identifier',
    hasParent: true,
  },
  {
    resource: 'variant',
    labelKey: 'general.options',
    archivePath: 'variants',
    entityPath: 'variants',
    hasParent: true,
  },
  {
    resource: 'paymentTerm',
    labelKey: 'configuration.navigation.paymentTerms',
    archivePath: 'paymentterms',
    entityPath: 'paymentterms',
    identifierLabelKey: 'configuration.identifier',
    hasParent: true,
  },
  {
    resource: 'supplier',
    labelKey: 'general.suppliers',
    archivePath: 'suppliers',
    entityPath: 'suppliers',
  },
  {
    resource: 'vatCode',
    labelKey: 'configuration.navigation.vatCodes',
    archivePath: 'vatcodes',
    entityPath: 'vatcodes',
    identifierLabelKey: 'configuration.identifier',
    hasParent: true,
  },
  {
    resource: 'user',
    labelKey: 'general.users',
    archivePath: 'users',
    entityPath: 'users',
    identifierLabelKey: 'general.email',
  },
];
